import { MANIFEST, type Manifest, type ManifestFile } from '../worlds/manifest.js';
import type { SoundPlan } from './plan.js';

/**
 * A recording's served loop in the worlds manifest, by its id
 * (`gulls-loop.ogg`): what the import measured of it -- its length and its
 * loudness -- and the name it is served under.
 */
export function recordingFile(id: string, manifest: Manifest = MANIFEST): ManifestFile {
  const file = manifest.files.find(
    (candidate) => candidate.served && candidate.kind === 'audio' && candidate.id === id,
  );
  if (!file) throw new Error(`no served sound ${id} in the worlds manifest`);
  return file;
}

/** The recordings a plan plays, each once. */
export function recordingsOf(plan: SoundPlan, manifest: Manifest = MANIFEST): ManifestFile[] {
  const ids = new Set<string>();
  for (const layer of plan.layers) if (layer.source.kind === 'recording') ids.add(layer.source.id);
  return [...ids].map((id) => recordingFile(id, manifest));
}
